/**
 * Service untuk mengelola operasi terkait jamaah
 */
import apiClient from './apiClient';

/**
 * Mengambil daftar jamaah dengan paginasi dan pencarian
 * 
 * @param {number} page - Halaman yang diinginkan
 * @param {number} perPage - Jumlah item per halaman
 * @param {string} search - Kata kunci pencarian
 * @param {string} status - Filter berdasarkan status (opsional)
 * @returns {Promise<{data: Array, meta: Object}>} - Daftar jamaah dan metadata
 */
export const getJamaahList = async (page = 1, perPage = 10, search = '', status = '') => {
  const queryParams = new URLSearchParams({
    page,
    perPage,
    ...(search ? { search } : {}),
    ...(status ? { status } : {})
  }).toString();
  
  // Gunakan path /jamaah (tanpa /api) untuk menyesuaikan dengan endpoint backend
  const response = await apiClient.get(`/jamaah?${queryParams}`);
  return response;
};

/**
 * Mengambil detail jamaah berdasarkan ID
 * 
 * @param {number} id - ID jamaah yang diinginkan
 * @returns {Promise<Object>} - Data detail jamaah
 */
export const getJamaahById = async (id) => {
  const response = await apiClient.get(`/jamaah/${id}`);
  return response.data;
};

/**
 * Membuat data jamaah baru
 * 
 * @param {Object} jamaahData - Data jamaah yang akan dibuat
 * @returns {Promise<Object>} - Data jamaah yang telah dibuat
 */
export const createJamaah = async (jamaahData) => {
  const response = await apiClient.post('/jamaah', jamaahData);
  return response.data;
};

/**
 * Memperbarui data jamaah
 * 
 * @param {number} id - ID jamaah yang akan diperbarui
 * @param {Object} jamaahData - Data jamaah yang akan diperbarui
 * @returns {Promise<Object>} - Data jamaah yang telah diperbarui
 */
export const updateJamaah = async (id, jamaahData) => {
  const response = await apiClient.put(`/jamaah/${id}`, jamaahData);
  return response.data;
};

/**
 * Menghapus data jamaah
 * 
 * @param {number} id - ID jamaah yang akan dihapus
 * @returns {Promise<boolean>} - Status keberhasilan penghapusan
 */
export const deleteJamaah = async (id) => {
  const response = await apiClient.delete(`/jamaah/${id}`);
  return response.data?.deleted || false;
};

export default {
  getJamaahList,
  getJamaahById,
  createJamaah,
  updateJamaah,
  deleteJamaah
};